(() => {
  // Hidden Shopify pages need their native preview URL until approved for publication.
  if (!['development', 'unpublished'].includes(window.Shopify?.theme?.role)) return;
  const connect = () => document.querySelectorAll('[data-liontek-professional-preview]').forEach(link => {
    link.href = link.dataset.liontekProfessionalPreview;
    link.rel = 'nofollow';
  });
  connect();
  if (!window.liontekProfessionalNavReady) {
    document.addEventListener('shopify:section:load', connect);
    window.liontekProfessionalNavReady = true;
  }
})();
